/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


document.addEventListener('DOMContentLoaded', () => {
    const accordionItems = document.querySelectorAll('.traveloptimizer-accordion__item');
    accordionItems.forEach(accordion => {
        const head = accordion.querySelector('.traveloptimizer-accordion__item-head');
        head.addEventListener('click', () => {
            accordion.classList.toggle('is-open');
        });

        const galleries = accordion.querySelectorAll('.wp-block-gallery');
        if(!galleries || galleries.length === 0) return;

        galleries.forEach(gallery => {
            const images = gallery.querySelectorAll('.wp-block-image');
            if(images.length)
                gallery.classList.add(`images-${images.length}`);
        });
    });
});
